// extracted by mini-css-extract-plugin
module.exports = {"previouslySeenProducts":"PreviouslySeenProducts_previouslySeenProducts__EoelO","header":"PreviouslySeenProducts_header__LTGps"};